import { GroupedCloserData } from "../settlementsDashboard/types";

export const getRelationships = (data: GroupedCloserData, people: string[]) => {
  const relationships: { [key: string]: string[] } = {};

  for (const [personName, personData] of Object.entries(data)) {
    const funders = personData.uniqueFunders || [];

    for (const person of people) {
      if (funders.includes(person)) {
        if (!relationships[personName]) {
          relationships[personName] = [];
        }
        relationships[personName].push(person);

        if (!relationships[person]) {
          relationships[person] = [];
        }
        relationships[person].push(personName);
      }
    }
  }

  return relationships;
};